import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/modules/(legal)/privacy-policy/PrivacyPolicy.tsx");
